module.exports = __webpack_public_path__ + "img/3_full.e0916d5a.jpg";